var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bs-wrapper auth-box"},[_vm._v("正在进入……")])
}
var staticRenderFns = []

export { render, staticRenderFns }